import { Flex, Center, Button, Heading, Text, VStack, HStack, Input } from '@chakra-ui/react';
import { useState } from 'react';
import toast from 'react-hot-toast';
import styled from 'styled-components';
import { useScreenWidth } from 'hooks/useScreenWidth';

const ComingSoonPage = () => {
    const [email, setEmail] = useState('');
    const screen = useScreenWidth();

    const handleNotifyMe = () => {
        if (!email) {
            toast.error('Please enter your email address', { position: 'top-right' });
            return;
        }

        if (!/\S+@\S+\.\S+/.test(email)) {
            toast.error('Please enter a valid email address', { position: 'top-right' });
            return;
        }

        // Replace with your actual notification logic
        toast.promise(
            new Promise((resolve) => {
                setTimeout(() => {
                    resolve();
                }, 1000);
            }),
            {
                loading: 'Subscribing...',
                success: <b>Thank you! We'll notify you when we launch.</b>,
                error: <b>Something went wrong. Please try again.</b>,
            },
            { position: 'top-right' },
        );

        setEmail('');
    };

    return (
        <Container>
            <Center minH="100vh" p="24px">
                <VStack spacing="30px" maxW="500px" w="100%">
                    {/* Logo or Brand Section */}
                    <Flex
                        borderRadius="10px"
                        w="180px"
                        h="180px"
                        bg="#1b3b5f"
                        justify="center"
                        align="center">
                        <Center>
                            {/* Replace with your logo/icon */}
                            <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M12 2L2 7V10C2 16 6 20.5 12 22C18 20.5 22 16 22 10V7L12 2Z"
                                    stroke="#F5F5F5"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M9 12L11 14L15 10"
                                    stroke="#F5F5F5"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </Center>
                    </Flex>

                    {/* Main Content */}
                    <VStack spacing="20px" textAlign="center">
                        <Heading
                            as="h1"
                            fontSize={screen > 500 ? '48px' : '36px'}
                            color="#1b3b5f"
                            fontWeight="700">
                            Coming Soon
                        </Heading>

                        <Text fontSize="18px" color="#202325" maxW="400px" lineHeight="1.6">
                            We're working hard to bring you something amazing.Stay tuned for our
                            launch!
                        </Text>

                        <Text fontSize="16px" color="#666" mt="10px">
                            Be the first to know when we go live
                        </Text>
                    </VStack>

                    {/* Email Subscription */}
                    <VStack spacing="15px" w="100%" maxW="400px">
                        <HStack w="100%" spacing="10px">
                            <Input
                                placeholder="Enter your email address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                borderRadius="48px"
                                h="48px"
                                border="2px solid #E2E8F0"
                                _focus={{
                                    border: '2px solid #1b3b5f',
                                    boxShadow: 'none',
                                }}
                                fontSize="16px"
                                px="20px"
                            />
                            <Button
                                color="#F5F5F5"
                                bg="#1b3b5f"
                                fontWeight="400"
                                borderRadius="48px"
                                h="48px"
                                px="30px"
                                outline="none"
                                _hover={{ bg: '#2a4a6b' }}
                                onClick={handleNotifyMe}
                                flexShrink={0}>
                                Notify Me
                            </Button>
                        </HStack>

                        {/* Alternative single button for mobile */}
                        {screen <= 500 && (
                            <Button
                                w="100%"
                                color="#F5F5F5"
                                bg="#1b3b5f"
                                mt="15px"
                                fontWeight="400"
                                borderRadius="48px"
                                h="48px"
                                outline="none"
                                _hover={{ bg: '#2a4a6b' }}
                                onClick={handleNotifyMe}>
                                Get Notified When We Launch
                            </Button>
                        )}
                    </VStack>

                    {/* Social Links or Additional Info */}
                    {/* <VStack spacing="15px" mt="40px">
                        <Text fontSize="14px" color="#666">
                            Follow us for updates
                        </Text>
                        <HStack spacing="20px">
                            <SocialButton>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                                </svg>
                            </SocialButton>
                            <SocialButton>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.566-1.35 2.14-2.21-.77.34-1.6.57-2.46.68z" />
                                </svg>
                            </SocialButton>
                            <SocialButton>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.098.119.112.223.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.16-1.507-.402-2.451-1.669-2.451-3.011 0-3.462 2.516-6.641 7.237-6.641 3.796 0 6.749 2.703 6.749 6.315 0 3.768-2.37 6.799-5.663 6.799-1.107 0-2.155-.577-2.512-1.336-.548 2.086-2.02 4.715-3.014 6.31 1.136.35 2.334.538 3.579.538 6.624 0 11.99-5.367 11.99-11.99C24.007 5.367 18.641.001 12.017.001z" />
                                </svg>
                            </SocialButton>
                        </HStack>
                    </VStack> */}

                    {/* Footer */}
                    <Text fontSize="12px" color="#999" mt="30px" textAlign="center">
                        © 2025 Obana.Africa. All rights reserved.
                    </Text>
                </VStack>
            </Center>
        </Container>
    );
};

export default ComingSoonPage;

const Container = styled.div`
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);

    @media screen and (max-width: 500px) {
        padding: 20px;
    }
`;

// const SocialButton = styled.button`
//     width: 40px;
//     height: 40px;
//     border-radius: 50%;
//     background: #1b3b5f;
//     color: #f5f5f5;
//     border: none;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     cursor: pointer;
//     transition: all 0.3s ease;

//     &:hover {
//         background: #2a4a6b;
//         transform: translateY(-2px);
//     }
// `;
